import { ActionsPage } from '../'
import { branch } from '../constants'

module.exports = (transaction) ->

  (await ActionsPage.list({ transaction }))
    .filter((configNode) -> configNode.get('serviceCall') is 'importExcel')
    .map((configNode) ->
      configNode.set('serviceCall', 'import')
      configNode.save({ transaction, branch })
    )
